export default function TwitterIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.887"
      height="21.035"
      viewBox="0 0 25.887 21.035"
      className={`h-6 fill-current ${className}`}
    >
      <g transform="translate(-6.93 -9.096)">
        <path
          d="M83.141,119.485a15.009,15.009,0,0,0,15.112-15.112c0-.23,0-.459-.016-.687a10.807,10.807,0,0,0,2.65-2.749,10.6,10.6,0,0,1-3.051.836,5.33,5.33,0,0,0,2.335-2.938,10.643,10.643,0,0,1-3.373,1.289,5.316,5.316,0,0,0-9.051,4.844A15.079,15.079,0,0,1,76.8,99.419a5.315,5.315,0,0,0,1.644,7.09,5.272,5.272,0,0,1-2.411-.665v.067a5.313,5.313,0,0,0,4.261,5.206,5.3,5.3,0,0,1-2.4.091A5.317,5.317,0,0,0,82.86,114.9a10.657,10.657,0,0,1-6.6,2.278A10.814,10.814,0,0,1,75,117.1a15.036,15.036,0,0,0,8.141,2.382"
          transform="translate(-68.07 -89.354)"
          fill="#bebebe"
        />
      </g>
    </svg>
  );
}
